import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconCollapseHorizontalStyle0 = gravityIconIndividualCss;

const GravityIconCollapseHorizontal = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'a4d5f8226dcbaceec74b0d99099ee5996a2b6403', color: this.color, size: this.size }, h("svg", { key: '644ec844c05e0c6dda646489ab5040f0bc66f799', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'd6571a8d9a79289e385b0c784beab82b5dc1e884', d: "M17.964 14.348c.403.341 1.034.064 1.034-.455v-5.79c0-.519-.63-.796-1.034-.454l-3.42 2.895a.591.591 0 0 0 0 .908l3.42 2.896Zm-6.716-11.35a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 .5-.5h.5ZM3.002 8.103c0-.519.63-.796 1.034-.454l3.42 2.895a.591.591 0 0 1 0 .909l-3.42 2.895c-.403.341-1.034.064-1.034-.455v-5.79Z", fill: "currentColor" }))));
    }
};
GravityIconCollapseHorizontal.style = GravityIconCollapseHorizontalStyle0;

export { GravityIconCollapseHorizontal as gravity_icon_collapse_horizontal };

//# sourceMappingURL=gravity-icon-collapse-horizontal.entry.js.map